function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7219 8.59666C18.7219 9.75071 17.7872 10.6854 16.6332 10.6854C15.48 10.6854 14.5444 9.75071 14.5444 8.59666C14.5444 7.44354 15.48 6.50793 16.6332 6.50793C17.7872 6.50793 18.7219 7.44354 18.7219 8.59666Z",
  fill: "#A7A7A7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.74533 14.7504L5.84814 15.9523C5.88939 15.9823 8.62228 17.9829 12.241 17.9829C14.0635 17.9829 16.1109 17.4748 18.1528 15.9523L17.2566 14.7495C12.0705 18.6166 6.9602 14.9108 6.7454 14.7504L6.74533 14.7504Z",
  fill: "#A7A7A7"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.6156 0H3.38445C1.51791 0 0 1.51779 0 3.38349V20.6165C0 22.4812 1.51779 24 3.38445 24H20.6175C22.4821 24 24 22.4813 24 20.6156V3.38349C24 1.51789 22.4822 0 20.6156 0V0ZM3.38445 1.49998H15.0366C14.1938 2.52842 12.9572 3.85683 11.3353 5.16835C10.8694 4.53367 10.0435 4.21774 9.2466 4.44836L5.83504 5.43928C4.81692 5.73553 4.22631 6.80988 4.52254 7.828L4.83847 8.91548C3.79787 9.30267 2.67943 9.61673 1.5001 9.85109V3.38339C1.5001 2.34559 2.34571 1.49996 3.38447 1.49996L3.38445 1.49998ZM22.4998 20.6153C22.4998 21.654 21.6542 22.4997 20.6154 22.4997H3.3843C2.34557 22.4997 1.49994 21.6541 1.49994 20.6153V11.3857C2.83867 11.1429 4.09311 10.7989 5.26214 10.3742L5.44964 11.0201C5.74495 12.0382 6.82024 12.6279 7.83742 12.3326L11.248 11.3408C12.2661 11.0454 12.8558 9.97015 12.5605 8.95297L11.9024 6.68424C14.3885 4.74646 16.0676 2.71684 16.9517 1.49982H20.6155C21.6543 1.49982 22.4999 2.34542 22.4999 3.38325L22.4998 20.6153Z",
  fill: "#00B0F0"
});

var SvgPirate = function SvgPirate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPirate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pirate.99a5239c.svg";
export { ForwardRef as ReactComponent };